var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_367_37833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.58834 5.19678H4.58834C4.23472 5.19678 3.89558 5.33725 3.64553 5.5873C3.39548 5.83735 3.255 6.17649 3.255 6.53011V12.5301C3.255 12.8837 3.39548 13.2229 3.64553 13.4729C3.89558 13.723 4.23472 13.8634 4.58834 13.8634H10.5883C10.942 13.8634 11.2811 13.723 11.5311 13.4729C11.7812 13.2229 11.9217 12.8837 11.9217 12.5301V10.5301",
    stroke: "#080808",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.58838 10.5301H8.58838L14.255 4.86343C14.5203 4.59822 14.6693 4.23851 14.6693 3.86343C14.6693 3.48836 14.5203 3.12865 14.255 2.86343C13.9898 2.59822 13.6301 2.44922 13.255 2.44922C12.88 2.44922 12.5203 2.59822 12.255 2.86343L6.58838 8.5301V10.5301Z",
    stroke: "#080808",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.255 3.86377L13.255 5.86377",
    stroke: "#080808",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_367_37833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.588379 0.530273)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.4407629a37d23ad6ba73a1fd45894f64.svg";
export { ForwardRef as ReactComponent };